import React from 'react';
import styled from '@benzinga/themetron';
import { Product, CompareProductField } from '@benzinga/content-manager';
import { ProductDropdown } from './ProductDropdown';
import { defaultProductFields, additionalProductFields } from './productFields';
import { CompareProductTableRow } from './CompareProductTableRow';
import { sanitizeHTML } from '@benzinga/frontend-utils';

interface SelectableCompareTableProps {
  compareCustomFields: CompareProductField[];
  currentSelection: Product[];
  productList: Product[];
  onChangeHandleSelectedProduct: (item, index) => void;
  productsToShow?: number;
}

export const SelectableCompareTable: React.FC<SelectableCompareTableProps> = ({
  compareCustomFields,
  currentSelection,
  onChangeHandleSelectedProduct,
  productList,
}) => {
  const currentComparingProducts = currentSelection;

  const getProductCustomField = (fieldKey: string, product: Product) => {
    const cs = product.details?.custom_sec ?? [];
    if (cs.length > 0) {
      const item = cs.find(feature => {
        return feature.label === fieldKey;
      });
      if (item) {
        return item.value;
      }
    }
    return '-';
  };

  return (
    <SelectableCompareProductTable className="wrapper-table py-3 mb-3">
      <table className="table-auto">
        <thead>
          <tr>
            <td></td>
            {currentComparingProducts &&
              currentComparingProducts.map((item, i) => {
                return (
                  <td key={item.id}>
                    <ProductDropdown
                      handleSelectedProduct={onChangeHandleSelectedProduct}
                      products={productList}
                      selectedProduct={item}
                      selectIndex={i}
                    />
                  </td>
                );
              })}
          </tr>
        </thead>
        <tbody>
          <CompareProductTableRow
            currentComparingProducts={currentComparingProducts}
            productFields={defaultProductFields}
          />

          {compareCustomFields &&
            Object.keys(compareCustomFields).map(key => {
              const customFieldKey = compareCustomFields[key].label;
              return (
                <tr key={customFieldKey}>
                  <td>{compareCustomFields[key].label}</td>
                  {currentComparingProducts.map(productItem => {
                    return (
                      <td key={productItem.id}>
                        <div
                          dangerouslySetInnerHTML={{
                            __html: sanitizeHTML(getProductCustomField(customFieldKey, productItem)),
                          }}
                        />
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          <CompareProductTableRow
            currentComparingProducts={currentComparingProducts}
            productFields={additionalProductFields}
          />
        </tbody>
      </table>
    </SelectableCompareProductTable>
  );
};

const SelectableCompareProductTable = styled.div`
  display: block;
  clear: both;
  border-bottom: 3px solid #cddaed;
  width: 100%;
  overflow-x: auto;
  table {
    border-radius: 4px;
    thead {
      td {
        border-top: none;
        &:first-of-type {
          border-left: none;
        }
        &:last-of-type {
          border-right: none;
        }
      }
    }
    tbody {
      tr {
        td {
          width: 30%;
          min-width: 170px;
          &:first-of-type {
            font-weight: 500;
            width: 10%;
            border-left: none;
            font-size: 16px;
          }
          &:last-of-type {
            border-right: none;
          }
        }
        &:last-of-type {
          td {
            border-bottom: none;
          }
        }
      }
    }
    td {
      padding: 6px 8px;
      border: 1.5px solid #ddd;
      vertical-align: top;
      min-width: 160px;
    }
  }
`;
